import type { InvoicesFilters } from '../types';

/**
 * Query key factory for invoices feature
 * Follows TanStack Query best practices for key organization
 */
export const invoiceKeys = {
  all: ['invoices'] as const,
  lists: () => [...invoiceKeys.all, 'list'] as const,
  list: (filters: InvoicesFilters) => [...invoiceKeys.lists(), filters] as const,
  details: () => [...invoiceKeys.all, 'detail'] as const,
  detail: (id: string) => [...invoiceKeys.details(), id] as const,
  html: (id: string) => [...invoiceKeys.all, 'html', id] as const,
  customers: () => [...invoiceKeys.all, 'customers'] as const,
  customer: (accountId: string) => [...invoiceKeys.all, 'customer', accountId] as const,
  salesUsers: () => [...invoiceKeys.all, 'salesUsers'] as const,
  contracts: (customerId: string) => [...invoiceKeys.all, 'contracts', customerId] as const,
  organisationUsers: (orgId: string) => [...invoiceKeys.all, 'orgUsers', orgId] as const,
  quotes: (accountId: string) => [...invoiceKeys.all, 'quotes', accountId] as const,
  projects: (accountId: string) => [...invoiceKeys.all, 'projects', accountId] as const,
  documents: (invoiceId: string) => [...invoiceKeys.all, 'documents', invoiceId] as const,
  activities: (invoiceId: string) => [...invoiceKeys.all, 'activities', invoiceId] as const,
  sensors: (invoiceNumber: string) => [...invoiceKeys.all, 'sensors', invoiceNumber] as const,
  contractDoc: (contractId: string) => [...invoiceKeys.all, 'contractDoc', contractId] as const,
};
